"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const AccountOrder_1 = tslib_1.__importDefault(require("../account-order-history/AccountOrder"));
const AccountOrderHistory = ({ orders, loggedIn }) => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: orders.map((order, index) => ((0, jsx_runtime_1.jsx)(AccountOrder_1.default, { order: order, isFirstOrder: index === 0, loggedIn: loggedIn }, order.orderId))) }));
exports.default = AccountOrderHistory;
